import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import SettingsApplications from '@mui/icons-material/SettingsApplications';
import ExtensionIcon from '@mui/icons-material/Extension';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ChatIcon from '@mui/icons-material/Chat';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import PaymentIcon from '@mui/icons-material/Payment';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ReorderIcon from '@mui/icons-material/Reorder';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ViewListIcon from '@mui/icons-material/ViewList';
import HelpIcon from '@mui/icons-material/Help';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

import themes from './themes';

export const configuredTheme = themes[0].theme;

export const configuredLayout = {
    currentLayout: 'classic',
    notificationsOpen: false,
};

const iconStyle = {
    fontSize: 16,
};
export const menuItems = [
    {
        title: 'Dashboard',
        href: '/',
        icon: <HomeIcon style={iconStyle} />,
    },
    {
        title: 'Users',
        icon: <PeopleIcon style={iconStyle} />,
        children: [
            {
                title: 'Normal Users',
                icon: <PeopleIcon style={iconStyle} />,
                children: [
                    {
                        title: 'All Users',
                        href: '/users',
                        icon: <PeopleIcon style={iconStyle} />,
                    },
                    {
                        title: 'Add User',
                        href: '/users/add',
                        icon: <PersonAddIcon style={iconStyle} />,
                    },
                ],
            },
            {
                title: 'Admin Users',
                icon: <PeopleIcon style={iconStyle} />,
                children: [
                    {
                        title: 'All Admin Users',
                        href: '/admin-users',
                        icon: <PeopleIcon style={iconStyle} />,
                    },
                    {
                        title: 'Add User',
                        href: '/admin-users/add',
                        icon: <PersonAddIcon style={iconStyle} />,
                    },
                ],
            },
        ],
    },
    {
        title: 'Manage Ads',
        icon: <NoteAddIcon style={iconStyle} />,
        children: [
            {
                title: 'Ads List',
                href: '/advertise-list',
                icon: <ViewListIcon style={iconStyle} />,
            },
            {
                title: 'Manage Category',
                icon: <PlaylistAddCheckIcon style={iconStyle} />,
                children: [
                    {
                        title: 'Category List',
                        href: '/category',
                        icon: <PlaylistAddCheckIcon style={iconStyle} />,
                    },
                    {
                        title: 'Add Category',
                        href: '/category/add',
                        icon: <PlaylistAddIcon style={iconStyle} />,
                    },
                ],
            },
        ],
    },
    {
        title: 'Question',
        icon: <HelpIcon style={iconStyle} />,
        children: [
            {
                title: 'Question List',
                href: '/question-list',
                icon: <EventNoteIcon style={iconStyle} />,
            },
            {
                title: 'Add Question',
                href: '/question/add',
                icon: <AddCircleIcon style={iconStyle} />,
            },
            {
                title: 'Assign Question',
                href: '/question/assign',
                icon: <AssignmentTurnedInIcon style={iconStyle} />,
            },
        ],
    },
    {
        title: 'Extra Feature',
        icon: <ExtensionIcon style={iconStyle} />,
        children: [
            {
                title: 'Extra Feature List',
                href: '/extra-feature',
                icon: <ExtensionIcon style={iconStyle} />,
            },
            {
                title: 'Add Extra Feature',
                href: '/extra-feature/add',
                icon: <ExtensionIcon style={iconStyle} />,
            },
        ],
    },
    {
        title: 'Locality',
        icon: <LocationCityIcon style={iconStyle} />,
        children: [
            {
                title: 'Locality List',
                href: '/locality',
                icon: <LocationCityIcon style={iconStyle} />,
            },
            {
                title: 'Add Locality',
                href: '/locality/add',
                icon: <LocationCityIcon style={iconStyle} />,
            },
        ],
    },
    {
        title: 'Reorder',
        icon: <ReorderIcon style={iconStyle} />,
        children: [
            {
                title: 'Locality',
                href: '/reorder-locality',
                icon: <EventNoteIcon style={iconStyle} />,
            },
            {
                title: 'Category',
                href: '/reorder-category',
                icon: <EventNoteIcon style={iconStyle} />,
            },
            {
                title: 'Extra Feature',
                href: '/reorder-extra-feature',
                icon: <EventNoteIcon style={iconStyle} />,
            },
            {
                title: 'Questions',
                href: '/reorder-questions',
                icon: <EventNoteIcon style={iconStyle} />,
            },
            {
                title: 'Options',
                href: '/reorder-options',
                icon: <EventNoteIcon style={iconStyle} />,
            },
        ],
    },
    {
        title: 'Feature Group',
        icon: <ExtensionIcon style={iconStyle} />,
        children: [
            {
                title: 'Extra Feature Group',
                icon: <PlaylistAddCheckIcon style={iconStyle} />,
                children: [
                    {
                        title: 'Extra Feature Group List',
                        href: '/feature-group/extra',
                        icon: <PlaylistAddCheckIcon style={iconStyle} />,
                    },
                    {
                        title: 'Add Extra Feature Group',
                        href: '/feature-group/extra/add',
                        icon: <PlaylistAddIcon style={iconStyle} />,
                    },
                ],
            },
            {
                title: 'Property Feature Group',
                icon: <PlaylistAddCheckIcon style={iconStyle} />,
                children: [
                    {
                        title: 'Property Feature Group List',
                        href: '/feature-group/property',
                        icon: <PlaylistAddCheckIcon style={iconStyle} />,
                    },
                    {
                        title: 'Add Property Feature Group',
                        href: '/feature-group/property/add',
                        icon: <PlaylistAddIcon style={iconStyle} />,
                    },
                ],
            },
        ],
    },
    {
        title: 'Transactions',
        href: '/transactions',
        icon: <PaymentIcon style={iconStyle} />,
    },
    {
        title: 'Broadcast',
        href: '/broadcast',
        icon: <AddAlertIcon style={iconStyle} />,
    },
    {
        title: 'Support',
        href: '/support',
        icon: <ChatIcon style={iconStyle} />,
    },
    {
        title: 'Basic Settings',
        icon: <SettingsApplications style={iconStyle} />,
        href: '/basic-settings/form',
    },
];

export const pusher = {
    APP_KEY: '1d58ee7b75c85accc630',
    APP_CLUSTER: 'ap2',
};
